<template>
  <router-view/>
</template>

<style>
 

@font-face {
    font-family: 'Manrope';
    src: url('~@/assets/fonts/Manrope/Manrope-VariableFont_wght.ttf');
}
@font-face {
    font-family: 'Figtree';
    src: url('~@/assets/fonts/Figtree/Figtree-VariableFont_wght.ttf');
}

@font-face {
    font-family: 'Helvetica';
    src: url('~@/assets/fonts/Helvetica/Helvetica.ttf');
}

@font-face {
    font-family: 'Arial';
    src: url('~@/assets/fonts/Arial/ARIAL.TTF');
}

@font-face {
    font-family: 'sans-serif';
    src: url('~@/assets/fonts/sans-serif/SansSerifFLF.otf');
}

@font-face {
    font-family: 'formular-regular';
    src: url('~@/assets/fonts/formular-regular/formular-regular.woff2');
}

@font-face {
    font-family: 'Georgia';
    src: url('~@/assets/fonts/Georgia/Georgia.woff');
}

@font-face {
    font-family: 'Georgia-Italic';
    src: url('~@/assets/fonts/Georgia-Italic/Georgia-Italic.woff');
}

@font-face {
    font-family: 'SourceSansPro-Bold';
    src: url('~@/assets/fonts/SourceSansPro-Bold/SourceSansPro-Bold.woff');
}

@font-face {
    font-family: 'SourceSansPro-Bold-Italic';
    src: url('~@/assets/fonts/SourceSansPro-BoldIt/SourceSansPro-BoldIt.woff');
}

@font-face {
    font-family: 'SourceSansPro-Italic';
    src: url('~@/assets/fonts/SourceSansPro-It/SourceSansPro-It.woff');
}

@font-face {
    font-family: 'SourceSansPro-Regular';
    src: url('~@/assets/fonts/SourceSansPro-Regular/SourceSansPro-Regular.woff');
}

</style>
